import { atom } from 'recoil'


interface QrBoradState {
  visible: boolean
  machineName?: string
  loginCode?: string
}

export const qrBoardState = atom<QrBoradState>({
  key: 'qrBoardState',
  default: {
    visible: false,
    machineName: undefined,
    loginCode: undefined,
  },
})
